import React, { PropTypes } from 'react'
import ListEntry from '../../shared/ListEntry'
import { personSubTitle } from '../../../common';
import { getCurrentLanguage } from '../../../localData';

const PersonEntry = ({ person, deleteEntry }) => (
    <ListEntry
        entry={{
            id: person.id,
            title: person.PerNameSortedTxt,
            txt: personSubTitle(person),
            linkUrl: `/${getCurrentLanguage()}/person/${ person.id }`,
            imageUrl: person.PerThumbnail,
            deleteEntry: deleteEntry,
        }}
    />
);

PersonEntry.propTypes = {
    person: PropTypes.object.isRequired,
    deleteEntry: PropTypes.func,
};

export default PersonEntry;


// WEBPACK FOOTER //
// ./app/components/Person/Entry/PersonEntry.jsx